import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { useLocalize } from "../i18n";
import { Button, Menu, MenuItem, Typography } from "@mui/material";
import LayersOutlinedIcon from "@mui/icons-material/LayersOutlined";
import { setCurrentIndex } from "../reducers/CategoriesSlice";

export function DesktopIndexMenu({ indices }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const localize = useLocalize();
  const currentIndex = useSelector((state) => state.categories?.currentIndex);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleSelect = (index) => {
    dispatch(setCurrentIndex(index));
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        onClick={(e) => setAnchorEl(e.currentTarget)}
        fullWidth
        aria-haspopup="menu"
        aria-expanded={Boolean(anchorEl)}
        sx={{
          color: "primary.main",
          borderRadius: "12px",
          padding: "10px 16px",
          backgroundColor: "rgba(255, 255, 255, 0.4)",
          backdropFilter: "blur(10px)",
          border: "1px solid rgba(var(--primary-rgb), 0.2)",
          minHeight: "42px",
          textTransform: "none",
          transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
          display: "flex",
          justifyContent: "space-between",
          "&:hover": {
            backgroundColor: "rgba(255, 255, 255, 0.6)",
            borderColor: "primary.main",
            transform: "translateY(-1px)",
            boxShadow: "0 4px 12px rgba(var(--primary-rgb), 0.1)",
          },
        }}
      >
        <Typography
          variant="body2"
          sx={{ fontWeight: 800, color: "primary.dark" }}
        >
          {currentIndex.short_name_en
            ? t("map.indexButton", {
                name: localize(currentIndex, "short_name"),
              })
            : t("map.chooseIndex")}
        </Typography>
        <LayersOutlinedIcon sx={{ fontSize: "20px" }} />
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        slotProps={{
          paper: {
            sx: {
              mt: 1,
              minWidth: 248,
              borderRadius: "12px",
              boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.15)",
            },
          },
        }}
      >
        {indices.map((indexItem) => {
          const isSelected =
            currentIndex.short_name_en === indexItem.short_name_en;
          return (
            <MenuItem
              key={indexItem.id}
              selected={isSelected}
              onClick={() => handleSelect(indexItem)}
              sx={{
                mx: 0.5,
                borderRadius: "8px",
                flexDirection: "column",
                alignItems: "flex-start",
                "&.Mui-selected, &.Mui-selected:hover": {
                  bgcolor: "primary.main",
                  color: "#fff",
                },
              }}
            >
              <Typography
                variant="body2"
                sx={{ fontWeight: isSelected ? 800 : 500 }}
              >
                {localize(indexItem, "short_name")}
              </Typography>
              {indexItem.full_name_en && (
                <Typography
                  variant="caption"
                  sx={{ opacity: 0.75, lineHeight: 1.3 }}
                >
                  {localize(indexItem, "full_name")}
                </Typography>
              )}
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
}
